import React from "react";
type SectionHeaderProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  tone?: "chalk" | "coral" | "pencil" | "light";
  center?: boolean;
};
const eyebrowTone = {
  chalk: "text-chalk",
  coral: "text-coral",
  pencil: "text-pencil-dark",
  light: "text-pencil"
};
export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  tone = "chalk",
  center = false
}: SectionHeaderProps) {
  const isLight = tone === "light";
  return <div className={center ? "text-center" : ""} data-id="element-258" data-mp="1apuch6yral5c">
      {eyebrow && <p className={`text-xs font-bold tracking-wide md:text-sm ${eyebrowTone[tone]}`} data-id="element-259" data-mp="15rj6j7bl0use">{eyebrow}</p>}
      <h2 className={`mt-1.5 font-display text-2xl font-bold leading-tight md:text-4xl ${center ? "mx-auto" : ""} max-w-2xl`} data-id="element-260" data-mp="1kgfcmyu2vxqd">{title}</h2>
      {subtitle && <p className={`mt-1.5 text-sm md:text-lg ${isLight ? "text-white/75" : "text-muted"} ${center ? "mx-auto" : ""} max-w-2xl`} data-id="element-261" data-mp="1ti5424nymwo5">{subtitle}</p>}
    </div>;
}